import { render, staticRenderFns } from "./folders-payments.vue?vue&type=template&id=d0567562&scoped=true"
import script from "./folders-payments.vue?vue&type=script&lang=js"
export * from "./folders-payments.vue?vue&type=script&lang=js"
import style0 from "./folders-payments.vue?vue&type=style&index=0&id=d0567562&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0567562",
  null
  
)

export default component.exports